<template>
  <div v-if="$route.name !='scorecard' && $route.name !='summary' && $route.name !='lanes'">
    <div class="footer">
      <div class="footer-mobile">
        <ul>
          <li>v1 BETA 06/22/25</li>
          <li>&copy; 2025 <a href="http://wildaxe.com/lumberjack/" target="_blank">Wild Axe Productions</a></li>
          <li>Built by <a href="https://www.topsailsoftware.ca/" target="_blanl">Topsail Software Inc</a></li>
          <li><a href="/privacy">Privacy Policy</a> | <a href="/terms">Terms</a></li>
          <li><a href="mailto: contact@axes2.ca">contact@axes2.ca</a></li>
        </ul>
      </div>
      <div class="footer-desktop">
        <p style="font-size: 0.8em">
          v1 BETA 06/22/2025 | 
          &copy; 2025 <a href="http://wildaxe.com/lumberjack/" target="_blank">Wild Axe Productions</a> | 
          Built by <a href="https://www.topsailsoftware.ca/" target="_blank">Topsail Software Inc</a> |
          <a href="/privacy">Privacy Policy</a> | <a href="/terms">Terms</a> | <a href="mailto: contact@axes2.ca">contact@axes2.ca</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Footer',
    methods: {
    },
    computed: {
    },
    mounted(){
    }
  }
</script>

<style lang="scss" scoped>
.footer {
  font-family: Verdana;
  background-color: black;
  color: white;
  width: 100%;
  height: 30px !important;
  max-height: 30px;
  font-size: 0.75em;
  font-style: Italic;
  text-align: center;
  bottom: 0px;
}

.footer-mobile {
  display: inline;
}
.footer-desktop {
  display: none;
}

@media screen and (min-width: 600px) {
  .footer-desktop {
    display: inline;
  }
  .footer-mobile {
    display: none;
  }
}


</style>